var Base = require('_js/base'),
  ko = require('knockout'),
  find = require('lodash/find'),
  filter = require('lodash/filter');

function SelectedList(params) {
  if (
    !params.emptyListEvent ||
    !params.removeItemEvent ||
    !params.updateListEvent
  ) {
    throw 'Need to provide events that SelectedList can listen and publish to.';
  }

  var self = this;
  this.emptyListEvent = params.emptyListEvent;
  this.removeItemEvent = params.removeItemEvent;
  this.updateListEvent = params.updateListEvent;

  this.containerClass = params.containerClass || '';
  this.items = ko.observableArray([]);

  // Update the list.
  ko.postbox.subscribe(
    this.updateListEvent,
    function(item) {
      self.items(item);
    },
    true
  );

  // Remove all items in the list.
  ko.postbox.subscribe(
    this.emptyListEvent,
    function() {
      self.items([]);
    },
    true
  );
}

SelectedList.prototype = new Base();

SelectedList.prototype.removeItem = function(key) {
  // Notify subscribers that item has been removed.
  ko.postbox.publish(
    this.removeItemEvent,
    find(this.items(), function(item) {
      if (item.Key === key) {
        return true;
      }
      return false;
    })
  );
  // Remove it from the list.
  this.items(
    filter(this.items(), function(item) {
      return item.Key !== key;
    })
  );
};

module.exports = SelectedList;
